let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8eSg1")).then(() => parcelRequire('532ll'));